<!-- Sign _in code start -->
<section class="sign-in_gail-gas d-flex align-items-center">
    <div class="container-fluid p-0">
        <div class="row d-flex justify-content-end">


            <!-- <div class="welcomeText">
                <h2>Welcome to <span>  CNG  Sales</span> </h2>
            </div> -->
            <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-8 col-xxl-8 bgContentSet">
                <div class="cardLoginContent">
                    <!-- <img src="images/login-page-image.svg" alt="logo" class="svgresponsive"> -->
                    <img src="images/login-page-res.png" alt="logo" >
                    <div class="contentWrapp">
                        <ul>
                            <li>
                                <div class="logoIcon">
                                    <a routerLink="/login/login" routerLinkActive="active" >     <img src="images/logo.svg" alt="logo"></a>
                                </div>
                            </li>
                            <li>
                                <h1>Welcome to CNG Mitra </h1>
                            </li>
                            <li>
                                <h4>Fuelling Greener Future</h4>
                                <p>Innovating today for a greener tomorrow</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-4 col-xxl-4 signSet">
                <div class="sign-in-cred-box">
                    <div class="logoCard">
                        <img src="images/gail-gas.png" alt="logo">
                    </div>
                    <h4>Log In</h4>
                    <form id="frmlogin_login" [formGroup]="loginForm" (ngSubmit)="doLogin()">
                        <div class="form-input-signcred">
                            <div class="mb-4 mb-1450-bottom-10 ">
                                <label class="form-label fieldRequired">Email
                                    ID/Mobile Number</label>
                                <input type="text" formControlName="username" class="form-control"
                                    id="exampleFormControlInput1">
                                <app-field-error-display
                                    [displayError]="isFieldValid('username') && loginForm.controls['username'].errors?.['required']"
                                    errorMsg="Mobile Number is required"></app-field-error-display>
                            </div>

                            <div class="mb-1">
                                <label for="exampleFormControlInput1" class="form-label fieldRequired">Password</label>
                                <div class="relative">
                                    <input type="password" maxlength=80 formControlName="password" class="form-control"
                                        [type]="showPassword ? 'text' : 'password'" />
                                    <button class="visibileEyeOnOff" type="button" (click)="togglePasswordVisibility()">
                                        <i class="bi"
                                            [ngClass]="showPassword ? 'bi-eye-fill' : 'bi-eye-slash-fill'"></i>
                                    </button>
                                </div>
                                <app-field-error-display
                                    [displayError]="isFieldValid('password') && loginForm.controls['password'].errors?.['required']"
                                    errorMsg="Password is required"></app-field-error-display>
                            </div>
                            <a routerLink="/forget/password" routerLinkActive="active" class="forgot_password">Forgot Password</a>

                        </div>
                        <!-- <div class="d-flex align-items-center">
                            <div class="captcha-here me-3">
                                <span>a F T g j</span>

                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16">
                                <path fill="none" stroke="rgba(0, 31, 64, 1)" stroke-linecap="round"
                                    stroke-linejoin="round" stroke-width="1.5"
                                    d="M4.75 10.75h-3m12.5-2c0 3-2.798 5.5-6.25 5.5c-3.75 0-6.25-3.5-6.25-3.5v3.5m9.5-9h3m-12.5 2c0-3 2.798-5.5 6.25-5.5c3.75 0 6.25 3.5 6.25 3.5v-3.5" />
                            </svg>
                        </div>
                        <div class="mb-5 mt-4 mb-1450-bottom">
                            <input type="" class="form-control captchaInput"  id="exampleFormControlInput1"
                                placeholder="Enter Captcha">
                        </div> -->

                        <!-- <div class="d-flex align-items-center">
                            <div class="captcha-here me-3">
                                <span>CAPTCHA: {{ captchaText }}</span>
                            </div>
                            <div class="mb-5 mt-4 mb-1450-bottom">
                                <input type="text" formControlName="captcha" placeholder="Enter CAPTCHA text" />
                                <app-field-error-display
                                    [displayError]="isFieldValid('captcha') && loginForm.controls['captcha'].errors?.['captchaInvalid']"
                                    errorMsg="Incorrect CAPTCHA entered"></app-field-error-display>
                                <app-field-error-display
                                    [displayError]="isFieldValid('captcha') && loginForm.controls['captcha'].errors?.['required']"
                                    errorMsg="CAPTCHA is required"></app-field-error-display>
                            </div>
                            <button class="" type="button" (click)="refreshCaptcha()">Refresh CAPTCHA</button>
                        </div> -->
                        <div class="d-flex flex-column align-items-center">
                            <div class="captchaSet">
                            <div class="captcha-here">
                               <span style="display:none;">  <!--CAPTCHA: --> {{ captchaText }}</span>
                                <span id="captcha" [innerHTML]="captchaImg"></span>
                                <button class="refreshCaptcha" type="button" (click)="refreshCaptcha()"><i class="fa fa-refresh" aria-hidden="true"></i></button>
                            </div>
                      
                                <div class="mb-1450-bottom">
                                    <input (paste)="(false)" type="text" placeholder="Enter Captcha" formControlName="captcha"  />
                                  
                                </div>
                                <div class="w-100">
                                <app-field-error-display
                                [displayError]="isFieldValid('captcha') && loginForm.controls['captcha'].errors?.['captchaInvalid']"
                                errorMsg="Incorrect CAPTCHA entered"></app-field-error-display> 
                            <app-field-error-display
                                [displayError]="isFieldValid('captcha') && loginForm.controls['captcha'].errors?.['required']"
                                errorMsg="&nbsp; &nbsp; CAPTCHA is required"></app-field-error-display>
                            
                            </div>
                        </div>
                            <div class="btn-format">
                                <!-- <button class="" type="button" (click)="refreshCaptcha()">Refresh CAPTCHA</button> -->
                                <!-- <button class="" type="button" (click)="refreshCaptcha()"><i class="fa fa-refresh" aria-hidden="true"></i></button> -->
                            </div>
                        </div>
                        <button type="submit" class="btn w-100 login-btn-credmain mb-4 mt-1 mb-1450-bottom">Login to
                            Continue</button>
                    </form>
                </div>
            </div>

        </div>
    </div>
</section>